import { render, staticRenderFns } from "./ViewFrame.vue?vue&type=template&id=4b2efc3b"
import script from "./ViewFrame.vue?vue&type=script&lang=js"
export * from "./ViewFrame.vue?vue&type=script&lang=js"
import style0 from "./ViewFrame.vue?vue&type=style&index=0&id=4b2efc3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports